import React, { ReactNode } from 'react';
import { Accordion } from '@europrocurement/flexy-components';
import { PaletteColor, useTheme } from '@mui/material';
import { useCurrentDossierCtx } from '@europrocurement/l2d-modules';
import DossierArticlesProcessesList from '../DossierArticlesProcessesList/DossierArticlesProcessesList';
import { DossierArticle } from '../../hooks';
import { DossierArticleProcessMenuItemProps } from '../DossierArticleProcessMenu/DossierArticleProcessMenu';

export type DossierArticlesProcessesProps = {
    title: string;
    statusLabel?: string;
    statusColor: PaletteColor;
    validatorTypeId: number;
    footer?: ReactNode;
    getItemActions?: (article: DossierArticle) => Array<DossierArticleProcessMenuItemProps>;
    articles: DossierArticle[];
};

const DossierArticlesProcesses: React.FunctionComponent<DossierArticlesProcessesProps> = function ({
    title,
    validatorTypeId,
    footer,
    getItemActions = () => [],
    articles,
    statusLabel,
    statusColor,
}) {
    const { palette } = useTheme();
    const { dossier } = useCurrentDossierCtx();

    return (
        <Accordion
            title={title}
            expandLabel={statusLabel}
            expanded
            expandColor={statusColor}
            sx={{ backgroundColor: palette.background.paper }}
            contentSxProps={{ gap: '16px', display: 'grid' }}
        >
            {dossier && (
                <DossierArticlesProcessesList
                    articles={articles}
                    dossier={dossier}
                    validatorTypeId={validatorTypeId}
                    legalAnnoucements={[]}
                    getItemActions={getItemActions}
                />
            )}
            {footer}
        </Accordion>
    );
};

export default DossierArticlesProcesses;
